<template>
  <div class="relationalDatabaseServiceResourceSearch">
    <Row :gutter="4" style="margin-bottom: 10px">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
            @on-change="changeCompanyID"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyIdList"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <!--按账户ID筛选  -->
        <Select
          v-model="accountSearchKey"
          filterable
          multiple
          :max-tag-count="1"
          :placeholder="$t('RAM.common.PleaseEnterAccountID')"
          @on-change="changeAccountId(accountSearchKey)"
          :transfer="true"
        >
          <Checkbox
            v-model="singleAccount"
            @on-change="selectAccountAll"
            style="display: block; text-align: right"
            v-if="accountList.length > 0"
          >{{ $t("alarms.common.allSelected") }}</Checkbox
          >
          <Option
            :value="item.id"
            v-for="item in accountList"
            :key="item.id"
          >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <Col span="5">
        <Input
          v-model="accountName"
          :placeholder="$t('RAM.common.filterByAccountName')"
          @on-search="searchAccountName()"
        />
      </Col>
      <Col span="5">
        <Input
          v-model="instanceId"
          :placeholder="$t('RAM.common.QuerybyInstanceID')"
        />
      </Col>
      <Col span="2">
        <Button
          v-hasPermission="['resourceConfigurationManagement:hwc:relationalDatabaseServiceResourceHwc:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button>
      </Col>
    </Row>
  </div>
</template>
<script>
import { getCookie } from "../../../../../utils/cookieUtil.js";
import TableRelationalDatabaseServiceResourceHwc from "./TableRelationalDatabaseServiceResourceHwc.vue";

var tableRelationalDatabaseServiceResourceHwc =
  TableRelationalDatabaseServiceResourceHwc;
export default {
  name: "RelationalDatabaseServiceResourceGcpSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      accountName: "",
      companyIdList: [],
      accountSearchKey: [],
      accountList: [],
      instanceId: "",
      singleAccount: false
    };
  },
  mounted() {
    if (this.company == 1) {
      this.listRegisterInformation();
    } else {
      this.queryHWCAccountBox();
    }
  },
  methods: {
    getData(){
      eventBus.$emit("instanceId", this.instanceId);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountSearchKey", this.accountSearchKey);
      tableRelationalDatabaseServiceResourceHwc.methods.showAll();
    },
    //查询公司
    listRegisterInformation() {
      this.$api.user.listRegisterInformation().then((res) => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
        this.accountSearchKey = [];
        this.queryHWCAccountBox();
      });
    },
    // 切换公司
    changeCompanyID() {
      this.accountSearchKey = [];
      this.queryHWCAccountBox();
    },
    queryHWCAccountBox() {
      if (this.company != 1) {
        this.companyId = this.company
      }
      this.$api.account
        .queryHWCAccountBox("companyId", this.companyId)
        .then(res => {
          this.accountList = res.data;
          //默认账户全选
          if (this.accountList) {
            for (let i = 0; i < this.accountList.length; i++) {
              this.accountSearchKey.push(this.accountList[i].id);
            }
          }
        });
    },
    // 按公司搜索
    searchCompany() {
      eventBus.$emit("companyId", this.companyId);
      // tableRelationalDatabaseServiceResourceHwc.methods.showAll();
    },
    // 按账户名称查询
    searchAccountName() {
      eventBus.$emit("accountName", this.accountName);
      // tableRelationalDatabaseServiceResourceHwc.methods.showAll();
    },
    // 按账户ID查询
    changeAccountId(val) {
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
    },
    selectAccountAll() {
      this.accountSearchKey = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.accountSearchKey.push(item.id);
        });
      } else {
        this.accountSearchKey = [];
      }
    },
  },
};
</script>
<style scoped>
.relationalDatabaseServiceResourceSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/hwc/rds/RelationalDatabaseServiceResourceHwcSearch.vue